
type Props = {
  value: string;
  className?: string;
  maxLength?: number;
}

export const CharacterCounter = ({ value, className, maxLength }: Props) => {
  return (
    <div
      className={`w-full md:text-sm text-xs text-black font-light text-right ${className}`}
    >
      {value.length}{' '}
      <span className="md:text-sm text-xs text-gray-text font-light">
        / {maxLength}
      </span>
    </div>
  );
};
